import { render } from "./Search.vue?vue&type=template&id=65cf57e7&scoped=true"
import script from "./Search.vue?vue&type=script&lang=ts"
export * from "./Search.vue?vue&type=script&lang=ts"

import "./Search.vue?vue&type=style&index=0&id=65cf57e7&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-65cf57e7"

export default script